import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "img-uploader" };
const _hoisted_2 = { class: "upload-list" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "mask" };
const _hoisted_5 = ["src"];
import { ref, reactive, watch } from "vue";
import { upload } from "@/api/upload";
import { ElMessage } from "element-plus";
import { Plus, ZoomIn, Delete } from "@element-plus/icons-vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Upload',
    props: {
        imgUrl: {
            type: Array,
            default: () => [],
        },
        imgIds: {
            type: Array,
            default: () => [],
        },
        index: {
            type: Number,
            default: 0,
        },
        width: {
            type: Number,
            default: 132,
        },
        height: {
            type: Number,
            default: 132,
        },
        limit: {
            type: Number,
            default: 1,
        },
    },
    emits: ["uploader"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const dialogVisible = ref(false);
        const previewUrl = ref("");
        const uploadBanner = ref();
        const form = reactive({
            pictureList: [],
        });
        // 监听props变化，用于编辑场景下显示已有图片
        watch(() => [props.imgUrl, props.imgIds], ([imgList, imgIds]) => {
            // 如果传入的图片列表为空，清空当前列表
            if (!Array.isArray(imgList) || imgList.length === 0) {
                form.pictureList = [];
                return;
            }
            // 比较当前列表和新列表的URL是否相同
            const currentUrls = JSON.stringify(form.pictureList.map((item) => item.pictureUrl));
            const newUrls = JSON.stringify(imgList);
            // 如果URL不同，说明是切换到新数据，更新图片列表
            if (currentUrls !== newUrls) {
                form.pictureList = imgList.map((url, idx) => ({
                    pictureId: imgIds[idx] || "",
                    pictureUrl: url,
                }));
            }
        }, {
            deep: true,
            immediate: true,
        });
        const beforeAvatarUpload = (rawFile) => {
            if (rawFile.type !== "image/jpeg" && rawFile.type !== "image/png") {
                ElMessage.error("只能上传jpeg/jpg/png格式图片");
                return false;
            }
            else if (rawFile.size / 1024 / 1024 > 20) {
                ElMessage.error("上传图片最大不超过20MB!");
                return false;
            }
            return true;
        };
        const handleUpload = async (file) => {
            const fd = new FormData();
            fd.append("file", file.file);
            const res = await upload(fd);
            if (res.success) {
                form.pictureList.push({
                    pictureUrl: res.data.path,
                    pictureId: res.data.fileId,
                });
                uploadBanner.value.handleRemove(file);
                emitUploader();
            }
            else {
                uploadBanner.value.handleRemove(file);
            }
        };
        const handleDelete = (idx) => {
            form.pictureList.splice(idx, 1);
            emitUploader();
        };
        const previewImage = (idx) => {
            previewUrl.value = form.pictureList[idx].pictureUrl;
            dialogVisible.value = true;
        };
        const emitUploader = () => {
            const pictureIds = form.pictureList.map((item) => item.pictureId);
            const pictureUrls = form.pictureList.map((item) => item.pictureUrl);
            emits("uploader", { pictureIds, pictureUrls }, props.index);
        };
        return (_ctx, _cache) => {
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_el_upload = _resolveComponent("el-upload");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.pictureList, (item, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: idx,
                            class: "upload-item",
                            style: _normalizeStyle(`width:${props.width}px;height:${props.height}px`)
                        }, [
                            _createElementVNode("img", {
                                src: item.pictureUrl,
                                style: { "width": "100%", "height": "100%" }
                            }, null, 8, _hoisted_3),
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_el_icon, {
                                    size: "24",
                                    color: "#fff",
                                    onClick: _withModifiers(($event) => (handleDelete(idx)), ["stop"])
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(Delete))
                                    ]),
                                    _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_el_icon, {
                                    size: "24",
                                    color: "#fff",
                                    onClick: _withModifiers(($event) => (previewImage(idx)), ["stop"])
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(ZoomIn))
                                    ]),
                                    _: 1
                                }, 8, ["onClick"])
                            ])
                        ], 4));
                    }), 128)),
                    _createVNode(_component_el_upload, {
                        class: "uploader",
                        style: _normalizeStyle(`width:${props.width}px;height:${props.height}px`),
                        action: "#",
                        accept: "image/png, image/jpeg",
                        multiple: props.limit > 1,
                        "http-request": handleUpload,
                        "show-file-list": false,
                        "before-upload": beforeAvatarUpload,
                        disabled: form.pictureList.length >= props.limit,
                        ref_key: "uploadBanner",
                        ref: uploadBanner
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                                class: "avatar-uploader-icon",
                                style: _normalizeStyle(`width:${props.width}px;height:${props.height}px`)
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(Plus))
                                ]),
                                _: 1
                            }, 8, ["style"])
                        ]),
                        _: 1
                    }, 8, ["style", "multiple", "disabled"])
                ]),
                _createVNode(_component_el_dialog, {
                    title: "查看大图",
                    modelValue: dialogVisible.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((dialogVisible).value = $event))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", null, [
                            _createElementVNode("img", {
                                style: { "width": "100%" },
                                src: previewUrl.value
                            }, null, 8, _hoisted_5)
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
